import { Menu as MenuIcon } from '@mui/icons-material';
import { AppBar as MuiAppBar } from '@mui/material';
import { IconButton as MuiIconButton } from '@mui/material';
import { Toolbar as MuiToolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IconButton } from 'components/ui/icons/IconButton/index.js';

export const AppBar = styled(MuiAppBar)(({ theme }) => ({
  'boxShadow': 'none',
  'height': 52,
  'backgroundColor': theme.palette.background.paper,
  'borderRadius': 6,
  'left': '10px',
  'width': 'calc(100vw - 20px)',
  'top': 10,
  'marginTop': 'var(--sandbox-banner-height, 0px)',
  '&::before': {
    content: '""',
    position: 'fixed',
    top: 'var(--sandbox-banner-height, 0px)',
    left: 0,
    width: '100%',
    height: 10,
    backgroundColor: theme.palette.background.default,
    zIndex: theme.zIndex.appBar,
  },
}));

export const ToolBar = styled(MuiToolbar)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: 'auto',
  boxShadow: 'none',
  borderRadius: 6,
  padding: '0px 20px !important',
  minHeight: 52,
  [theme.breakpoints.down('md')]: {
    padding: '10px !important',
  },
}));

export const LogoWrapper = styled(IconButton)({
  display: 'flex',
  padding: 0,
});

export const Menu = styled(MenuIcon)(({ theme }) => ({
  '& path': {
    fill: theme.palette.primary.main,
  },
}));

export const MenuButton = styled(MuiIconButton)(({ theme }) => ({
  'height': 45,
  'display': 'none',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    alignItems: 'center',
    height: 30,
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));
